import React, { useEffect, useRef, useState } from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { CodeBlock, nord  } from 'react-code-blocks';
import { marked } from 'marked';  // Use marked library to parse markdown to HTML
import { Box, Typography, Tooltip } from "@mui/material";
import { FiCopy } from "react-icons/fi"; // React Icons
import styles from '../styles/Chatbot.module.css'

const ChatMarkdown = ({replyed}) => {

    const [copy_code, setCopy_code] = useState(false);

    const handleCodeCopy = (code) => {
        navigator.clipboard.writeText(code).then(() => {
            setCopy_code(true)
            }).catch((err) => {
                console.error('Failed to copy text: ', err);
                });
                setTimeout(() => {
                    setCopy_code(false);
                    }, 2000);
    }

  return (
    <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
            code({ inline, className, children, ...props }) {
                const match = /language-(\w+)/.exec(className || "");
                const codeText = String(children).replace(/\n$/, "");

                return !inline && match ? (
                    <Box sx={{ position: "relative", my: 2 }}>
                        {/* Language Header & Copy Button */}
                        <Box
                            className={styles.code_header}
                        >
                            <Typography variant="body2">{match[1].toUpperCase()}</Typography>
                            <button type={"button"} className={styles.copy} 
                            onMouseDown={(e) => {
                                e.stopPropagation(); // Prevent unnecessary bubbling
                                handleCodeCopy(codeText);
                                console.log("clicked");
                            }}
                            >
                                <FiCopy />
                                {copy_code ? <span>Copied!</span> : <span>Copy</span>}
                            </button>
                        </Box>

                        {/* Code Block */}
                        <CodeBlock
                            text={codeText}
                            language={match[1]}
                            showLineNumbers
                            theme={nord }
                            wrapLines
                            codeBlock
                        />
                    </Box>
                ) : (
                    <code className={className} {...props} style={{ backgroundColor: "#f5f5f5", padding: "2px 5px", borderRadius: "3px" }}>
                        {children}
                    </code>
                );
            },
        }}
        >
        {replyed}   
        </Markdown>
  )
}

export default ChatMarkdown
